import type {RvProduct} from 'src/api/local'
import {useCheckout} from 'src/context/CheckoutContext'

export const useQtyInCart = ({product}: {product: RvProduct}): number => {
  const {checkout} = useCheckout()
  const id = checkout?.lines?.find((line) => line?.variant.sku === product.sku)
  return id?.quantity ?? 0
}
